import Base from "./_BaseComponent";
import $ from "jquery";
import "flexslider";

const PROMO_URL = "https://portal.tilling.com.au/promo_public/get_rewards/6";
const POINT_URL = "https://portal.tilling.com.au/promo_public/get_summary/";
const PROMO_CLAIM_URL = "https://portal.tilling.com.au/promo_public/claim/{{companyId}}/{{accessKey}}";

const POINT_MAP: any = {
	"bronze": [35000, 69999],
	"silver": [70000, 139999],
	"gold": [140000, 279000],
	"platinum": [280000, 999999999]
}

class Smartreward extends Base.Component {
	private loader: JQuery;
	private flexslider: JQuery;
	private rewardData: any;
	private rewardContainers: any;
	private pointData: any;
	private pointSummaryEl: JQuery;
	private companyId: string;
	private accessKey: string;

	public  async onMount(): Promise<void> {
		this.pointData = null;
		this.rewardContainers = {};
		this.companyId = "";
		this.accessKey = "";

		this.loader = this.element.find(".loading");
		this.element.find("[data-reward-level]").each((idx: number, el: HTMLElement) => {
			const level = $(el).attr("data-reward-level");
			this.rewardContainers[level] = {
				container: $(el),
				flex: $(el).find("[data-slide-entry]"),
				rewards: []
			};
		});

		this.pointSummaryEl = this.element.find("[data-component-point-summary]");

		await this.fetchRewards();
		await this.fetchPoints();

		this.renderRewards();

		if (this.pointData)
			this.renderPoints();
	}

	private async fetchPoints(): Promise<any> {
		const url = new URL(window.location.href);
		this.companyId = url.searchParams.get("c");
		this.accessKey = url.searchParams.get("k");

		if (! this.companyId || ! this.accessKey)
			return;

		try {
			const body = await $.get({
				url: `${POINT_URL}${this.companyId}/${this.accessKey}`
			});

			this.pointData = body.data;
		} catch (e) {
			console.error(e);
		}
	}

	private async fetchRewards(): Promise<any> {
		try {
			const body = await $.get({
				url: PROMO_URL
			});

			this.rewardData = body.data;
		} catch (e) {
			console.error(e);
		}
	}

	private renderRewards(): void {
		// Organize rewards into groups.
		for (let reward of this.rewardData.rewards) {
			let cost = parseInt(reward.point_cost);

			for (let key in POINT_MAP) {
				const cmp: any = POINT_MAP[key];
				if (cost >= cmp[0] && cost <= cmp[1]) {
					this.rewardContainers[key].rewards.push(reward);
					break;
				}
			}
		}

		// Write the HTML in each group.
		for (let key in this.rewardContainers) {
			const group = this.rewardContainers[key];
			let buffer = '<ul class="slides"><li><div class="reward-slide">';
			let i = 1;

			let buttons = '';
			if (this.pointData && this.pointData.balance >= POINT_MAP[key][0]) {
				let permaLink = PROMO_CLAIM_URL.replace(/{{companyId}}/g, this.companyId);
				permaLink = permaLink.replace(/{{accessKey}}/g, this.accessKey);
				buttons = `<a class="btn" href="${permaLink}" target="_blank">Claim now</a>`;
			}

			for (let reward of group.rewards) {
				buffer += `
					<div class="entry">
						<div>
							<div class="img">
								<img src="${reward.image_url}" alt="{${reward.name}}" />
							</div>
							<div class="product-title">${reward.name}</div>
							<div class="description">${reward.description}</div>
						</div>
						<div class="points">${reward.point_cost} points</div>
						<div class="buttons">
							${buttons}
						</div>
					</div>
				`;

				if (i++ % 3 == 0)
					buffer += '</div></li><li><div class="reward-slide">';
			}

			buffer += '</div></li></ul>';

			buffer = buffer.replace(/<li><\/li>/g, '');

			group.flex.html(buffer);

			setTimeout(() => {
				group.flex.flexslider({
					controlNav: false,
					directionNav: true,
					animation: "slide",
					slideshow: true,
					slideshowSpeed: 5000
				});

				this.loader.hide();
			}, 100);
		}

	}

	private renderPoints(): void {
		this.pointSummaryEl.find("[data-points-redeemable]").each((idx: number, el: HTMLElement) => {
			$(el).html(this.pointData.balance.toLocaleString("en"));
		});

		this.pointSummaryEl.find("[data-points-potential]").each((idx: number, el: HTMLElement) => {
			$(el).html(this.pointData.potential.toLocaleString("en"));
		});

		let permaLink = PROMO_CLAIM_URL.replace(/{{companyId}}/g, this.companyId);
		permaLink = permaLink.replace(/{{accessKey}}/g, this.accessKey);

		this.pointSummaryEl.find("[data-point-claim-link]").attr("href", permaLink);

		this.pointSummaryEl.removeClass("hiding");

		// Point states.
		this.element.find("[data-points-group-state]").each((idx: number, el: HTMLElement) => {

			const group = $(el).attr("data-points-group-state");
			this.renderPointState(group, $(el));

		});
	}

	private renderPointState(group: string, el: JQuery): void {
		if (! POINT_MAP.hasOwnProperty(group)) {
			console.log(`No point map found for ${group}`);
			return;
		}

		if (this.pointData.balance >= POINT_MAP[group][0]) {
			// Eligible.
			el.find("[data-summary]").html(`You are eligible to redeem ${group.toUpperCase()} LEVEL REWARDS!`);
		} else {
			// Not eligible.
			const diff = POINT_MAP[group][0] - this.pointData.balance;
			el.find("[data-summary]").html(`You are ${diff.toLocaleString("en")} redeemable points away from being eligible for ${group.toUpperCase()} LEVEL REWARDS`);
		}

		el.find("[data-points-label]").html(`${this.pointData.balance.toLocaleString('en')} redeemable points`);

		let perc = Math.round(this.pointData.balance / POINT_MAP[group][0] * 100); 
		if (perc < 0) 
			perc = 0;
		if (perc > 100) 
			perc = 100;

		el.find("[data-points-label]").css("margin-left", `calc(${perc}% - 20px)`);
		el.find("[data-points-bar]").css("width", `${perc}%`);

		el.removeClass("hiding");

	}

	/*
	const POINT_MAP: any = {
	"bronze": [35000, 69999],
	"silver": [70000, 139999],
	"gold": [140000, 279000],
	"platinum": [280000, 999999999]
}
*/

}

export default Base.Init("[data-component-smartreward]", Smartreward);
